import React, { useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch'; 
import { useSelector } from 'react-redux';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import MainLayout from '../../layouts/MainLayout';
import './styles/TestBook.css';

const TestBookSeries = () => {
    const authState = useSelector(state => state.authReducer);
    
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const [userCode, setUserCode] = useState(authState.user.think5whyscode);
    const [institutionCode, setInstitutionCode] = useState('');
    const [groupCode, setGroupCode] = useState('');
    const [teacherCode, setTeacherCode] = useState('');
    const [isMySeries, setIsMySeries] = useState(false);

    const [selectedTTBExamId, setSelectedTTBExamId] = useState('');
    const [ttbExamMasterList, setTTBExamMasterList] = useState([]);
    const [ttbSeriesMasterList, setTTBSeriesMasterList] = useState([]);
    const [ttbSetMasterList, setTTBSetMasterList] = useState([]);

    const [examSection, setExamSection] = useState('');
    const [examSubSection, setExamSubSection] = useState('');
    const [filteredExams, setFilteredExams] = useState([]);
    const [filteredSeries, setFilteredSeries] = useState([]);
    const [isRefreshClicked, setIsRefreshClicked] = useState(false);

    // Fetch the exam data
    const fetchTTBExamMasters = useCallback(() => {
        const config = {
            url: "/ttbexams/exams",
            method: "post",
            headers: { Authorization: authState.token },
            data: { isActive: true },
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response.examlist)) {
                    setTTBExamMasterList(response.examlist);
                } else {
                    console.error("Invalid response format: Exam master list not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching set masters:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchTTBExamMasters();
    }, [authState.isLoggedIn, fetchTTBExamMasters]);

    useEffect(() => {
        if (examSection && examSubSection) {
            const filtered = ttbExamMasterList.filter(exam => 
                exam.examSection === examSection && exam.examSubSection === examSubSection
            );
            setFilteredExams(filtered);
        } else {
            setFilteredExams(ttbExamMasterList); 
        }
    }, [examSection, examSubSection, ttbExamMasterList]);

    const sortedTTBExamMasterList = [...filteredExams].sort((a, b) => a.examTitle.localeCompare(b.examTitle));

    const handleTTBExamMasterView = (examId, linkName) => {
        setSelectedTTBExamId(prevId => (prevId === examId ? null : examId));
        // alert(`You clicked ${linkName}`);
    };

    const handleExamSectionChange = (e) => {
        setExamSection(e.target.value);
        setExamSubSection(''); // Reset examSubSection when examSection changes
    };

    const handleExamSubSectionChange = (e) => {
        setExamSubSection(e.target.value);
    };

    const [linkClicked, setLinkClicked] = useState('Exam Info');
    const handleLinkClick = (linkName, examId) => {
        // console.log("linkName ",linkName, examId);
        setLinkClicked(linkName);
    };

    const [subLinkClicked, setSubLinkClicked] = useState('');
    const handleSubLinkClick = (subLinkName, examId) => {
        setSubLinkClicked(subLinkName);
        // console.log("linkName  ",linkClicked, examId);
        if(linkClicked === "Test Series" && subLinkName === "Refresh")
        {
            // console.log("subLinkName ",subLinkName);
            fetchTTBSeriesMasters(examId, subLinkName);
        }
    };

    // Fetch the series data
    const fetchTTBSeriesMasters = useCallback((examId, subLinkName) => {
        const config = {
            url: "/ttbseries/series",
            method: "post",
            headers: { Authorization: authState.token },
            data: { examId: examId, userCode: userCode, subLink: subLinkName },
        };
        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("response ",response)

                if (response && Array.isArray(response.serieslist)) {
                    setTTBSeriesMasterList(response.serieslist);
                } else {
                    console.error("Invalid response format: Series master list not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching set masters:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        // console.log("Updated ttbSeriesMasterList:", ttbSeriesMasterList);

    }, [fetchTTBSeriesMasters]);

    const sortedTTBSeriesMasterList = [...ttbSeriesMasterList].sort((a, b) => a.seriesTitle.localeCompare(b.seriesTitle));

    const handlePersonal = async () => {
        // setShowMOMForm(!showMOMForm);
    };

    const handleSetClick = (examId, seriesId, setQuestionType) => {
        if (setQuestionType === "MCQ") {
            navigate("/testbook-practicemcq", {
                state: { examId: examId, seriesId: seriesId, setQuestionType: setQuestionType },
            });
        } else {
            navigate("/testbook-practicesat", {
                state: { examId: examId, seriesId: seriesId, setQuestionType: setQuestionType },
            });
        }
    };
    

    return (
        <MainLayout>
            <div className="w-full">
                <h3 className="text-xl font-semibold text-white mt-12 mb-6 border-b-4 border-blue-600 pb-2">
                    ThinkTestBook - Series
                </h3>

                {loading ? (
                    <Loader />
                ) : (
                    <div className="flex flex-col gap-6 mt-6">
                        <div className="flex flex-col flex-wrap gap-6 px-4 border-2 border-yellow-200">
                            <div className="flex gap-6">
                                <div className="w-full sm:w-1/2">
                                    <label htmlFor="examSection" className="block text-white text-sm">Select Exam Section</label>
                                    <select
                                        id="examSection"
                                        value={examSection}
                                        onChange={handleExamSectionChange}
                                        className="w-full p-2 rounded-md bg-white text-gray-700"
                                    >
                                        <option value="">--Select Section--</option>
                                        {[...new Set(ttbExamMasterList.map(exam => exam.examSection))].map(section => (
                                            <option key={section} value={section}>{section}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="w-full sm:w-1/2">
                                    <label htmlFor="examSubSection" className="block text-white text-sm">Select Exam Subsection</label>
                                    <select
                                        id="examSubSection"
                                        value={examSubSection}
                                        onChange={handleExamSubSectionChange}
                                        className="w-full p-2 rounded-md bg-white text-gray-700"
                                        disabled={!examSection}
                                    >
                                        <option value="">--Select Subsection--</option>
                                        {examSection && 
                                            [...new Set(ttbExamMasterList.filter(exam => exam.examSection === examSection).map(exam => exam.examSubSection))].map(subsection => (
                                                <option key={subsection} value={subsection}>{subsection}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="flex gap-2">
                                <div className="w-1/3">
                                    <label htmlFor="institutionCode" className="block text-white text-sm">
                                        Institution
                                    </label>
                                    <input
                                        id="institutionCode"
                                        value={institutionCode}
                                        onChange={(e) => setInstitutionCode(e.target.value)}
                                        className="w-full p-2 rounded-md bg-white text-gray-700"
                                    />
                                </div>

                                <div className="w-1/3">
                                    <label htmlFor="groupCode" className="block text-white text-sm">
                                        Group
                                    </label>
                                    <input
                                        id="groupCode"
                                        value={groupCode}
                                        onChange={(e) => setGroupCode(e.target.value)}
                                        className="w-full p-2 rounded-md bg-white text-gray-700"
                                    />
                                </div>

                                <div className="w-1/3">
                                    <label htmlFor="teacherCode" className="block text-white text-sm">
                                        Teacher/Mentor
                                    </label>
                                    <input
                                        id="teacherCode"
                                        value={teacherCode}
                                        onChange={(e) => setTeacherCode(e.target.value)}
                                        className="w-full p-2 rounded-md bg-white text-gray-700"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap">
                                <label className="block text-white text-sm">
                                    <input
                                        className="mr-4"
                                        type="checkbox"
                                        checked={isMySeries}
                                        onChange={(e) => setIsMySeries(e.target.checked)}
                                    />
                                    Get Only For Me
                                </label>
                            </div>
                            <div className="mb-2 text-sm">
                                <button
                                    className='bg-purple-700 mt-2'
                                    onClick={handlePersonal}
                                    style={{ maxWidth: '300px', height: '44px'}}
                                    >
                                    Search Personalised Series
                                </button>
                            </div>
                        </div>


                        {filteredExams.length === 0 ? (
                            <div className="w-full flex items-center justify-center text-yellow-500 text-xl">
                                No records found!
                            </div>
                        ) : (
                            sortedTTBExamMasterList.map((ttbExamMaster, index) => (
                                <div
                                    key={ttbExamMaster._id}
                                    className="bg-white w-full p-2 my-2 text-gray-600 rounded-md shadow-md"
                                >
                                    <div className="flex justify-between items-center">
                                        <div className="text-sm text-black">
                                            {index + 1}. {ttbExamMaster.examAuthority}
                                        </div>
                                        <Tooltip text={"View details"} position={"top"}>
                                            <span
                                                className="ml-4 text-blue-500 cursor-pointer text-lg"
                                                onClick={() => handleTTBExamMasterView(ttbExamMaster._id, "View Details")}
                                            >
                                                <i className="fa-solid fa-eye"></i>
                                            </span>
                                        </Tooltip>
                                    </div>
                                    {selectedTTBExamId === ttbExamMaster._id && (
                                        <>
                                        <div className="bg-gray-600 p-4 mt-1 rounded-lg text-white">
                                            {/* <div
                                                className={`flex gap-6 mb-2 flex-wrap ${
                                                    subLinkClicked === "Refresh" ? "bg-blue-500" : "bg-blue-800"
                                                } text-white`}
                                            >
                                                {[
                                                    "By ThinkTestBook",
                                                    "By My Institution",
                                                    "By My Teacher",
                                                    "For My Group",
                                                    "For Me",
                                                    "Refresh",
                                                ].map((subLinkName, index) => (
                                                    <a
                                                        key={index}
                                                        href="#!"
                                                        onClick={() => handleSubLinkClick(subLinkName, ttbExamMaster._id)}
                                                        className={`text-sm ${
                                                            subLinkClicked === subLinkName
                                                                ? "text-yellow-200 font-bold"
                                                                : "text-white"
                                                        } hover:text-yellow-200 hover:border-b-2 hover:border-yellow-200`}
                                                    >
                                                        {subLinkName}
                                                    </a>
                                                ))}
                                            </div> */}

                                            {ttbSeriesMasterList.length === 0 ? (
                                                <div className="w-full flex items-center justify-center text-yellow-500 text-sm">
                                                    No records found!
                                                </div>
                                            ) : (
                                                sortedTTBSeriesMasterList.map((ttbSeriesMaster) => {
                                                    // const filteredSets = sortedTTBSetMasterList.filter(
                                                    //     (ttbSetMaster) => ttbSetMaster.seriesId === ttbSeriesMaster._id
                                                    // );

                                                    return (
                                                        <div
                                                            key={ttbSeriesMaster._id}
                                                            className="bg-gray-700 w-full p-2 my-2 text-white rounded-md shadow-md"
                                                        >
                                                            <p className="text-sm font-semibold">
                                                                <a
                                                                    onClick={() =>
                                                                        handleSetClick(ttbSeriesMaster.examId, ttbSeriesMaster._id, ttbSeriesMaster.seriesQuestionType)
                                                                    }
                                                                    className="text-yellow-200 hover:text-yellow-200 hover:border-b-2 hover:border-yellow-200"
                                                                >
                                                                    {ttbSeriesMaster.seriesTitle}
                                                                </a>
                                                            </p>
                                                            <p className="text-sm">{ttbSeriesMaster.seriesDesc}</p>
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </div>
                                        {/* <div className="mt-4 flex gap-6 mb-4 flex-wrap bg-blue-800 text-white">
                                            {["Exam Info", "Overview", "Test Series", "Practice Sets", "My Practices", "My Analysis", "Live Chat", "Coaching", "Exam Dates", "Exam News", "Results"].map((linkName, index) => (
                                                <a
                                                key={index}
                                                href="#!"
                                                onClick={() => handleLinkClick(linkName, ttbExamMaster._id)}
                                                className={`text-sm ${
                                                  linkClicked === linkName ? "text-yellow-200 font-bold" : "text-white"
                                                } hover:text-yellow-200 hover:border-b-2 hover:border-yellow-200`}
                                              >
                                                {linkName}
                                              </a>
                                            ))}
                                        </div> */}
                                        {/* { linkClicked === 'Exam Info' && (
                                            <div className="bg-gray-600 p-4 mt-2 rounded-lg text-white">
                                                <h2 className="text-sm text-yellow-200">
                                                    <strong>{ttbExamMaster.examTitle}{' - '}{ttbExamMaster.examAuthority}</strong>
                                                </h2>
                                                <p className="mt-2 text-sm">
                                                    <strong>Exam Category:</strong> {ttbExamMaster.examSection}
                                                </p>

                                                <p className="mt-2 text-sm">
                                                    <strong>Exam Subcategory:</strong> {ttbExamMaster.examSubSection}
                                                </p>
                                            </div>
                                        )} */}
                                        {/* { linkClicked === 'Overview' && (
                                            <div className="bg-gray-600 p-4 mt-2 rounded-lg text-white"
                                                dangerouslySetInnerHTML={{ __html: ttbExamMaster.examOverview }}
                                            />
                                        )} */}
                                        {/* { linkClicked === 'Test Series' && (
                                            <div className="bg-gray-600 p-4 mt-1 rounded-lg text-white">
                                                <div
                                                    className={`flex gap-6 mb-2 flex-wrap ${
                                                        subLinkClicked === "Refresh" ? "bg-blue-500" : "bg-blue-800"
                                                    } text-white`}
                                                >
                                                    {[
                                                        "By ThinkTestBook",
                                                        "By My Institution",
                                                        "By My Teacher",
                                                        "For My Group",
                                                        "For Me",
                                                        "Refresh",
                                                    ].map((subLinkName, index) => (
                                                        <a
                                                            key={index}
                                                            href="#!"
                                                            onClick={() => handleSubLinkClick(subLinkName, ttbExamMaster._id)}
                                                            className={`text-sm ${
                                                                subLinkClicked === subLinkName
                                                                    ? "text-yellow-200 font-bold"
                                                                    : "text-white"
                                                            } hover:text-yellow-200 hover:border-b-2 hover:border-yellow-200`}
                                                        >
                                                            {subLinkName}
                                                        </a>
                                                    ))}
                                                </div>

                                                {ttbSeriesMasterList.length === 0 ? (
                                                    <div className="w-full flex items-center justify-center text-yellow-500 text-sm">
                                                        No records found!
                                                    </div>
                                                ) : (
                                                    sortedTTBSeriesMasterList.map((ttbSeriesMaster) => {
                                                        // const filteredSets = sortedTTBSetMasterList.filter(
                                                        //     (ttbSetMaster) => ttbSetMaster.seriesId === ttbSeriesMaster._id
                                                        // );

                                                        return (
                                                            <div
                                                                key={ttbSeriesMaster._id}
                                                                className="bg-gray-700 w-full p-2 my-2 text-white rounded-md shadow-md"
                                                            >
                                                                <p className="text-sm font-semibold">
                                                                    <a
                                                                        onClick={() =>
                                                                            handleSetClick(ttbSeriesMaster.examId, ttbSeriesMaster._id, ttbSeriesMaster.seriesQuestionType)
                                                                        }
                                                                        className="text-yellow-200 hover:text-yellow-200 hover:border-b-2 hover:border-yellow-200"
                                                                    >
                                                                        {ttbSeriesMaster.seriesTitle}
                                                                    </a>
                                                                </p>
                                                                <p className="text-sm">{ttbSeriesMaster.seriesDesc}</p>
                                                            </div>
                                                        );
                                                    })
                                                )}

                                            </div>
                                        )} */}
                                        {/* { linkClicked === 'Practice Sets' && (
                                            <div className="bg-gray-600 p-4 mt-1 rounded-lg text-white">
                                                <div className="flex gap-6 mb-2 flex-wrap bg-blue-800 text-white">
                                                    {["MCQ", "Descriptive", "Mock Tests", "Previous Papers"].map((subLinkName, index) => (
                                                        <a
                                                        key={index}
                                                        href="#!"
                                                        onClick={() => handleSubLinkClick(subLinkName, ttbExamMaster._id)}
                                                        className={`text-sm ${
                                                        subLinkClicked === subLinkName ? "text-yellow-200 font-bold" : "text-white"
                                                        } hover:text-yellow-200 hover:border-b-2 hover:border-yellow-200`}
                                                    >
                                                        {subLinkName}
                                                    </a>
                                                    ))}
                                                </div>
                                            </div>
                                        )} */}
                                        {/* { linkClicked === 'My Practices' && (
                                            <div className="bg-gray-600 p-4 mt-1 rounded-lg text-white">
                                                <div className="flex gap-6 mb-2 flex-wrap bg-blue-800 text-white">
                                                    {["MCQ", "Descriptive", "Previous Papers", "AI Evaluated", "Teacher Evaluated"].map((subLinkName, index) => (
                                                        <a
                                                        key={index}
                                                        href="#!"
                                                        onClick={() => handleSubLinkClick(subLinkName, ttbExamMaster._id)}
                                                        className={`text-sm ${
                                                        subLinkClicked === subLinkName ? "text-yellow-200 font-bold" : "text-white"
                                                        } hover:text-yellow-200 hover:border-b-2 hover:border-yellow-200`}
                                                    >
                                                        {subLinkName}
                                                    </a>
                                                    ))}
                                                </div>
                                            </div>
                                        )} */}
                                        {/* { linkClicked === 'My Analysis' && (
                                            <div className="bg-gray-600 p-4 mt-1 rounded-lg text-white">
                                                <div className="flex gap-6 mb-2 flex-wrap bg-blue-800 text-white">
                                                    {["Bar Graph", "Line Graph", "Scatter Plot", "Comparison", "Time Spent", "RCA", "Fishbone", "Monthly Report"].map((subLinkName, index) => (
                                                        <a
                                                        key={index}
                                                        href="#!"
                                                        onClick={() => handleSubLinkClick(subLinkName, ttbExamMaster._id)}
                                                        className={`text-sm ${
                                                        subLinkClicked === subLinkName ? "text-yellow-200 font-bold" : "text-white"
                                                        } hover:text-yellow-200 hover:border-b-2 hover:border-yellow-200`}
                                                    >
                                                        {subLinkName}
                                                    </a>
                                                    ))}
                                                </div>
                                            </div>
                                        )} */}
                                        {/* { linkClicked === 'Coaching' && (
                                            <div className="bg-gray-600 p-4 mt-1 rounded-lg text-white">
                                                <div className="flex gap-6 mb-2 flex-wrap bg-blue-800 text-white">
                                                    {["Instant Paid", "Scheduled Paid", "Instant Free", "Scheduled Free"].map((subLinkName, index) => (
                                                        <a
                                                        key={index}
                                                        href="#!"
                                                        onClick={() => handleSubLinkClick(subLinkName, ttbExamMaster._id)}
                                                        className={`text-sm ${
                                                        subLinkClicked === subLinkName ? "text-yellow-200 font-bold" : "text-white"
                                                        } hover:text-yellow-200 hover:border-b-2 hover:border-yellow-200`}
                                                    >
                                                        {subLinkName}
                                                    </a>
                                                    ))}
                                                </div>
                                            </div>
                                        )} */}
                                        </>
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                )}
            </div>
        </MainLayout>
    );
};

export default TestBookSeries;
